class ImageBanner extends HTMLElement {
  constructor() {
    super();

    this.carousel = this.querySelector(".carousel-inner");
    console.log("this.carousel", this.carousel);
    this.banners = this.querySelectorAll(".banner");
    this.controls = this.querySelectorAll(".banner-control");

    this.onControlClick = this.handleControlClick.bind(this);
    this.nextBanner = this.handleNextBanner.bind(this);

    this.carouselHeight = 0;

    this.resizeBanners();
    window.addEventListener("resize", this.resizeBanners.bind(this));

    // controls
    this.controls.forEach((control) => {
      control.addEventListener("click", this.onControlClick);
    });

    this.currentBannerIndex = 0;
    if (this.banners.length > 1) {
      this.bannerInterval = setInterval(this.nextBanner, 5500);
    }
  }

  resizeBanners() {
    this.carouselHeight = 0;
    this.banners.forEach((banner) => {
      if (banner.offsetHeight > this.carouselHeight) {
        this.carouselHeight = banner.offsetHeight;
      }
    });

    // this.carousel.style.height = `${this.carouselHeight}px`;
  }

  handleWindowResize() {
    this.resizeBanners();
  }

  handleNextBanner() {
    if (this.currentBannerIndex < this.banners.length - 1) {
      this.currentBannerIndex++;
    } else {
      this.currentBannerIndex = 0;
    }
    this.controls[this.currentBannerIndex].click();
  }

  hideBanners() {
    this.banners.forEach((banner) => {
      banner.classList.remove("banner-active");
      banner.classList.add("banner-hidden");
    });
  }

  handleControlClick(evt) {
    clearInterval(this.bannerInterval);

    const control = evt.target;

    const controlIndex =
      parseInt(control.dataset.control.replace("banner-", "")) - 1;

    const banner = this.querySelector(`#${control.dataset.control}`);

    this.hideBanners();
    banner.classList.add("banner-active");

    this.currentBannerIndex = controlIndex;

    if (this.banners.length > 1) {
      this.bannerInterval = setInterval(this.nextBanner, 5500);
    }
  }
}

customElements.define("image-banner", ImageBanner);
